<template>
  <div class="home">
    <Header/>
    <div class="content main-box">
      <div class="Carousel center">
        <div>
          <p class="Carousel-p1">{{$t('home.title')}}</p>
          <p class="Carousel-p2">Ocean remote sensing big data information service and decision center</p>
          <p class="Carousel-p3">{{$t('home.introduce')}}</p>
        </div>
        <svg t="1637977640437" class="icon animation" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2615" width="32" height="32"><path d="M511.29 793.97L156.26 480.04l-56.52 63.92 411.44 363.81L924.2 544.02l-56.4-64.04z" p-id="2616" fill="#ffffff"></path><path d="M924.2 206.95l-56.4-64.04L511.29 456.9 156.26 142.97 99.74 206.9l411.44 363.81z" p-id="2617" fill="#ffffff"></path></svg>
      </div>
      <div class="announcement">
        <div class="announcement-mask">
          <div class="notice-scroll">
            <span class="notice-title">{{$t('home.Platform')}}</span>
            <Notice style="margin-top:2px;margin-left:80px;flex:1;"/>
          </div>
          <span class="notice-more" style="cursor:pointer" @click="$router.push({name:'Notice'})">{{$t('home.ViewAll')}} ></span>
        </div>
      </div>
      <div class="dataView">
        <div class="product-data">
          <div class="model-header">
            <div class="line"></div>
            <span class="name">{{$t('home.ProductCategoricalData')}}</span>
            <div class="line"></div>
          </div>
          <div class="product-img" style="margin-top:60px;">
            <div class="hysw">
              <div class="model-name l1" style="cursor: pointer">
                <img src="@/assets/image/home/product/1.png" alt="">
                <div class="mask center2" @click="$router.push({name:'product',query:{typeId:0}})">
                  <p>{{$t('home.MarineHydrology')}}</p>
                  <p>({{menuListPro[0].typeNum}})</p>
                </div>
              </div>
            </div>
            <div class="right-img">
              <div class="right-img-top">
                <div class="model-name t1" >
                  <img src="@/assets/image/home/product/2.png" alt="">
                  <div class="mask center2" @click="$router.push({name:'product',query:{typeId:2}})">
                    <p>{{$t('home.MarineMeteorology')}}</p>
                    <p>({{menuListPro[2].typeNum}})</p>
                  </div>
                </div>
                <div class="model-name t2">
                  <img src="@/assets/image/home/product/3.png" alt="">
                  <div class="mask center2" @click="$router.push({name:'product',query:{typeId:4}})">
                    <p>{{$t('home.PolarMarine')}}</p>
                    <p>({{menuListPro[4].typeNum}})</p>
                  </div>
                </div>
                <div class="model-name t3">
                  <img src="@/assets/image/home/product/6.png" alt="">
                  <div class="mask center2" @click="$router.push({name:'product',query:{typeId:5}})">
                    <p>{{$t('home.Topography')}}</p>
                    <p>({{menuListPro[5].typeNum}})</p>
                  </div>
                </div>
              </div>
              <div class="right-img-bottom">
                <div class="model-name b1">
                  <img src="@/assets/image/home/product/4.png" alt="">
                  <div class="mask center2" @click="$router.push({name:'product',query:{typeId:1}})">
                    <p>{{$t('home.MarineBiology')}}</p>
                    <p>({{menuListPro[1].typeNum}})</p>
                  </div>
                </div>
                <div class="model-name b2">
                  <img src="@/assets/image/home/product/5.png" alt="">
                  <div class="mask center2" @click="$router.push({name:'product',query:{typeId:3}})">
                    <p>{{$t('home.MarineEcology')}}</p>
                    <p>({{menuListPro[3].typeNum}})</p>
                  </div>
                </div>
                <div class="model-name b3">
                  <img src="@/assets/image/home/product/7.png" alt="">
                  <div class="mask center2" @click="$router.push({name:'product',query:{typeId:6}})">
                    <p>{{$t('home.ObservationData')}}</p>
                    <p>({{menuListPro[6].typeNum}})</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p class="more" @click="$router.push('product')">{{$t('home.ViewAll')}} >></p>
        </div>
        <div class="satellite-data">
          <div class="model-header">
            <div class="line"></div>
            <span class="name">{{$t('home.SatelliteCategoricalData')}}</span>
            <div class="line"></div>
          </div>
          <div class="satellite-content">
            <div class="satellite-content-list">
              <div class="satellite-data-site" :style="{'padding-top':(isEnglish?'0':'16px'),'padding-top':(isEnglish?'0':'16px')}" v-for="(i) in satelliteData" :key="i.index">
                <p class="satellite-name" @click="$router.push({name:'satelliteData',query:{typeId:i.pkid}})">{{i.name}}</p>
                <p class="satellite-data-box">
                  <span class="satellite-ke">{{$t('home.NumberofSatellites')}}：{{i.SateNum}}<span style="margin-left:0;"> {{i.SateNum>1?$t('home.Stars'):$t('home.Star')}}</span></span>
                  <span class="satellite-jing" style="white-space: pre-line;">{{$t('home.Scenesofdatafile')}}：{{isEnglish?`\n`:''}}{{i.SateImageNum}}<span style="margin-left:0;"> {{i.SateImageNum>1?$t('home.scenes'):$t('home.scene')}}</span></span>
                  <span class="satellite-memory" style="white-space: pre-line;">{{$t('home.DataStorage')}}：{{isEnglish?`\n`:''}}{{i.memory}}</span>
                </p>
                <hr>
              </div>
            </div>
            <div class="satellite-content-image" style="position: relative">
              <p style="text-align:right;margin:0 auto;color:rgba(2, 105, 255, 1);cursor: pointer;position: absolute;left: -140px;bottom: 0;" @click="$router.push('satelliteData')">{{$t('home.ViewAll')}} >></p>
              <img src="@/assets/image/927bfe93c35e4041a83bb6ce11f0ab6.png" alt="">
            </div>
          </div>
        </div>
        <div class="related-suggestion">
          <div class="width12">
            <div class="new related-layout">
              <div class="model-header">
                <div class="line"></div>
                <span class="name">{{$t('home.LatestProductData')}}</span>
                <div class="line"></div>
              </div>
              <div class="data-list">
                <p style="cursor:pointer" v-for="i in newProductData" :key="i.index" @click="$router.push({name:'product-detail',query:{ProductId:i.pkid}})">{{i.dataName}}<span>{{i.dataPublishTime.substr(0,10)}}</span></p>
              </div>
              <div style="width:100%" class="center">
                <span class="more" @click="$router.push('product')">{{$t('home.ViewAll')}} ></span>
              </div>
            </div>
            <div class="hot related-layout">
              <div class="model-header">
                <div class="line"></div>
                <span class="name">{{$t('home.PopularProductData')}}</span>
                <div class="line"></div>
              </div>
              <div class="data-list">
                <div class="hot-date-site" v-for="(i,index) in hotData" :key="index">
                  <div class="hot-date-site-left">
                    <img :src="require('@/assets/image/home/'+(index+1)+'.png')" alt="">
                    <span style="cursor:pointer" :class="hotDataColor(index)" @click="$router.push({name:'product-detail',query:{ProductId:i.pkid}})">{{i.dataName}}</span>
                  </div>
                  <span class="hot-date-site-right" :class="hotDataColor(index)">{{i.dataGlanced}} ↑</span>
                </div>
              </div>
              <div style="width:100%" class="center">
                <span class="more" @click="$router.push('product')">{{$t('home.ViewAll')}} ></span>
              </div>
            </div>
          </div>
        </div>
        <div class="satellite-data">
          <div class="model-header">
            <div class="line"></div>
            <span class="name">{{$t('home.PictureoftheDay')}}</span>
            <div class="line"></div>
          </div>
          <div class="meiriyitu">
            <div class="center">
              <!-- swiper-no-swiping -->
              <swiper class="swiper" ref="mySwiper" :options="swiperOptions" style="width:95%;" v-if="dayImageInfo.length">
                <swiper-slide
                  v-for="item in dayImageInfo"
                  :key="item.index"
                  style="height:730px;">
                  <div style="width:100%;margin:0 auto;">
                    <p class="jia-p" style="font-size:18px;justify-content:center;font-weight: 600;">{{item.productName}}</p>
                    <p class="jia-p" style="justify-content:center;margin-top:8px;">{{$t('home.Datatime')}}：{{item.imageTime}}</p>
                    <div class="center" style="width:80%;margin: 0 auto">
                      <img :src="mediaDown+item.imageDownloadUrl" alt="" style="max-width:95%;margin:0 auto;">
                    </div>
                    <p class="jia-p" style="padding: 0 40px">
                      <span>{{$t('home.CartographicInstitution')}}：{{item.mapCompany}}</span>
                      <span style="text-align:left;display: inline-block;width: 250px">{{$t('home.CoordinateSystem')}}：{{item.coordinate}}</span>
                    </p>
                    <p class="jia-p" style="padding: 0 40px">
                      <span >{{$t('home.ProcessingDate')}}：{{item.createTime}}</span>
                      <span style="text-align:left;display: inline-block;width: 250px">{{$t('home.ScaleBar')}}：{{item.scale}}</span>
                    </p>
                  </div>
                </swiper-slide>
                <div slot="button-prev" class="swiper-button-prev" @click="prevBtn"></div>
                <div slot="button-next" class="swiper-button-next" @click="nextBtn"></div>
              </swiper>
            </div>
          </div>
        </div>
        <div class="News-Center">
          <div class="model-header">
            <div class="line"></div>
            <span class="name">{{$t('home.NewsCenter')}}</span>
            <div class="line"></div>
          </div>
          <div class="news-showcase">
            <div class="image-box" v-if="newList.length>0">
              <img :src="newList.length>0?mediaDown+newList[newAcIndex].newsPic:''" alt="">
            </div>
            <div class="news-list">
              <div class="news-type">
                <div @click="changeNews(i.type)" :class="newForm.category==index+1?'new-site-ac center':'new-site center'" :style="{'margin':(index===1?'0 12px':'')}" v-for="(i,index) in newsType" :key="i.index">
                  {{$t(`home.${i.name}`)}}
                </div>
              </div>
              <div class="news-list-box">
                <div class="news-site" v-for="(i,index) in newList" :key="index">
                  <div class="news-date">
                    <p class="day">{{i.day}}</p>
                    <p class="year">{{i.year}}</p>
                  </div>
                  <div class="news-line"></div>
                  <div class="news-content">
                    <p @click="$router.push({name:'News',query:{id:i.pkid}})" :class="index===newAcIndex?'news-content-title-ac':'news-content-title'">{{i.newsTitle}}</p>
                    <p class="news-content-detail">{{i.newsIntro}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p class="more" @click="$router.push('newsList')">{{$t('home.ViewAll')}} >></p>
        </div>
        <div class="Resource-Statistics">
          <div class="model-header">
            <div class="line"></div>
            <span class="name">{{$t('home.AlgorithmStatistics')}}</span>
            <div class="line"></div>
          </div>
          <div class="count-box" style="margin-top:24px;">
            <div class="count-site">
              <img src="@/assets/image/home/icon1.png" alt="">
              <p>
                <span class="count-num">{{suanfaTJ.algorithmCount}}</span>
                <span class="count-unit">{{$t('home.pcs')}}</span></p>
              <p class="count-name">{{$t('home.TotalNumberofAlgorithms')}}</p>
            </div>

            <div class="count-site">
              <img src="@/assets/image/home/icon2.png" alt="">
              <p>
                <span class="count-num">{{suanfaTJ.algoProductCount}}</span>
                <span class="count-unit">{{$t('home.pcs')}}</span></p>
              <p class="count-name">{{$t('home.TotalNumberofProducedProducts')}}</p>
            </div>

            <div class="count-site">
              <img src="@/assets/image/home/icon3.png" alt="">
              <p>
                <span class="count-num">{{byte2Auto(parseInt(suanfaTJ.fileSpaceUsage)).substr(0, byte2Auto(parseInt(suanfaTJ.fileSpaceUsage)).length - 2)}}</span>
                <span class="count-unit">{{byte2Auto(parseInt(suanfaTJ.fileSpaceUsage)).substr(byte2Auto(parseInt(suanfaTJ.fileSpaceUsage)).length - 2,2)}}</span></p>
              <p class="count-name">{{$t('home.TotalProducedDataVolume')}}</p>
            </div>
          </div>
        </div>
        <div class="Resource-Statistics">
          <div class="model-header">
            <div class="line"></div>
            <span class="name">{{$t('home.ResourceStatistics')}}</span>
            <div class="line"></div>
          </div>
          <div class="count-box">
            <div class="count-site" v-for="(i,index) in resourseList" :key="i.index">
              <!-- <img :src="i.url" alt=""> -->
              <span :class="i.class" style="font-size: 38px;"></span>
              <p>
                <span class="count-num">{{i.num}}</span>
                <span class="count-unit">{{$t(`home.${i.unit}`)}}</span></p>
              <p class="count-name">{{$t(`home.${i.name}`)}}</p>
              <div class="count-line" v-if="index<resourseList.length-1"></div>
            </div>
          </div>
        </div>
        <div class="Service-Statistics">
          <div class="model-header">
            <div class="line"></div>
            <span class="name">{{$t('home.ServiceStatistic')}}</span>
            <div class="line"></div>
          </div>
          <div class="count-box">
            <div class="count-site" v-for="(i,index) in serverList" :key="i.index">
              <!-- <img :src="i.url" alt=""> -->
              <span :class="i.class" style="font-size: 38px;"></span>
              <p>
                <span class="count-num">{{i.num}}</span>
                <span class="count-unit">{{$t(`home.${i.unit}`)}}</span></p>
              <p class="count-name">{{$t(`home.${i.name}`)}}</p>
              <div class="count-line" v-if="index<serverList.length-1"></div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import Notice from "@/components/Notice"
//导入swiper
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import {
  getNwestList,
  getHotList,
  allProductSum,
  allSatelliteSum,
  serviceStatMenAndGlanced,
  getIndexSum,
  dayImage,
  browseRecord,
  getSumAlgorithm,
  sumMutipleStTypes
} from "@/api/home/index"
import { getShopCarList} from "@/api/product/index"
import {getNews} from "@/api/news"
export default {
  name: 'Home',
  components: {
    Notice,
    Header,
    Footer,
    swiper,
    swiperSlide
  },
  data(){
    return{
      swiperOptions: {
        watchSlidesVisibility: true,
        navigation: {
          prevEl: 'swiper-button-prev', // 后退按钮的css选择器或HTML元素。
          nextEl: 'swiper-button-next', // 前进按钮的css选择器或HTML元素。
        },
        loop:true,
        loopAdditionalSlides: 1,
      },
      dayImageInfo:[],
      dayImageInfoIndex:0,
      menuListPro:[
        {typeNum:''},
        {typeNum:''},
        {typeNum:''},
        {typeNum:''},
        {typeNum:''},
        {typeNum:''},
        {typeNum:''},
      ],
      suanfaTJ:{
        algoProductCount: "1",
        algorithmCount: "6",
        fileSpaceUsage: "5534781280"
      },
      newList:[
        // {day:'20',year:'2021-07',isAc:true,newsTitle:'首艘智能型无人系统母船在广州开工建造',newsPic:require('../assets/image/home/new/1.png'),content:'7月20日，智能型无人系统母船在广州开工建造。该船拥有“i-ship（No，R1，M，I）”智能船级符号，有望成为全球首艘具有远程遥控和开阔水域自主航行功能的科考船，将为我国开展海洋科考提供前所未有的利器。 国家卫星海洋应用中心蒋兴伟院士，中船黄埔文冲船舶有限公司向辉明党委书记、董事长，中船集团第七〇一所李维林副所长，中船集团第七〇四所高晓敏所长，我实验室主任陈大可院士、副主任'},
        // {day:'01',year:'2021-10',isAc:false,newsTitle:'百年正风华，奋进新征程！庆祝中国共产党成立100周年！',newsPic:require('../assets/image/home/new/2.png'),content:'兴起于暗夜的星星之火，绽出万丈霞光。劈开混沌的一叶红船，驶向光明未来。 在庆祝中国共产党成立一百周年大会上，习近平总书记指出，一百年来，中国共产党团结带领中国人民，以“为有牺牲多壮志，敢教日月换新天”的大无畏气概，书写了中华民族几千年历史上最恢宏的史诗。这一百年来开辟的伟大道路、创造的伟大事业、取得的伟大成就，必将载入中华民族发展史册、人类文明发展史册！”'},
        // {day:'28',year:'2021-01',isAc:false,newsTitle:'潮平岸阔催人进，风起扬帆再向前 ——南方海洋实验室第一届理事会第三次会议顺利召开',newsPic:require('../assets/image/home/new/3.png'),content:'2021年1月28日，我实验室第一届理事会第三次会议在珠海召开。科技部原部长徐冠华院士、中山大学校长罗俊院士、珠海市市长姚奕生、学术委员会主任苏纪兰院士等实验室理事会领导和成员出席会议。广东省科技厅省实验室建设推进工作小组温则伟副组长、实验室与平台基地处黄江康处长、中山大学邰忠智副校长、实验室副主任张培震院士、实验室副主任王辉研究员以及珠海市财政局、科创局、中山大学有关负责同志列'},
        // {day:'18',year:'2020-12',isAc:false,newsTitle:'围观！带你走近南方海洋实验室智能型无人系统母船',newsPic:require('../assets/image/home/new/4.png'),content:'12月18日，我实验室与中国舰船研究设计中心、中船黄埔文冲船舶共同签署了智能型无人系统母船的设计建造合同。 作为有望成为全球首艘取得远程遥控（R1）船级符号的智能型科考船。南方海洋实验室此艘智能型无人系统母船究竟有哪些过人之处呢？ 时代呼唤 海洋科学作为一门以观测为主要手段的战略科学，其发展在很大程度上依赖于先进仪器设备的开发。纵观海洋科学史，所有重大突破无一不是技术设备创新的结果。近几十年来，随着海洋卫星、Argo剖面浮标、锚定浮标/潜标网、水下滑翔机'},
      ],
      menuList:[
        {title:"首页"},
        {title:"数据资源",children:[
          {title:'卫星数据' ,url:'/satellite'},
          {title:'产品数据'},
          {title:'一张图展示'},
        ]},
        {title:"服务资源",children:[
          {title:'算法库'},
          {title:'数据服务'},
          {title:'云计算服务(GP)'},
          {title:'开发SDK'},
        ]},
        {title:"数据汇交"},
        {title:"可视化分析"},
        {title:"专题服务"},
        {title:"极地冰情"},
        {title:"关于我们"},
      ],
      newProductData:[
      ],
      hotData:[
      ],
      resourseList:[
        {num:'0',unit:'pcs',name:'TotalNumberofProductData',class:'iconfont icon-chanpin ziyuan'},
        {num:'0',unit:'GB',name:'TotalVolumeofProductData',class:'iconfont icon-shuju_mian ziyuan'},
        {num:'0',unit:'scenes',name:'TotalNumberofSatelliteData',class:'iconfont icon-weixing ziyuan'},
        {num:'0',unit:'TB',name:'TotalVolumeofSatelliteData',class:'iconfont icon-fl-shuju ziyuan'},
      ],
      serverList:[
        {num:'0',unit:'persons',name:'NumberofRegisteredUsers',class:'iconfont icon-renshu ziyuan'},
        {num:'0',unit:'freq',name:'WebsiteVisits',class:'iconfont icon-fangwenliang ziyuan'},
        {num:'0',unit:'GB',name:'TotalDownloadVolume',class:'iconfont icon-APPxiazailiang ziyuan'},
        {num:'0',unit:'freq',name:'TotalDownloadCounts',class:'iconfont icon-xiazaishujuku ziyuan'},
      ],
      satelliteData:[
        {name:'Terra/Aqua',SateNum:'2',SateImageNum:'273839',memory:'12',typeId:1,pkid:"1464960963546451969"},
        {name:'Sentinel',SateNum:'6',SateImageNum:'71015',memory:'9.4',typeId:3,pkid:"1464960686177128450"},
        {name:'Himawari',SateNum:'2',SateImageNum:'109086',memory:'11.98',typeId:5,pkid:"1464960792288825345"},
        {name:'Landsat',SateNum:'2',SateImageNum:'10428',memory:'9.72',typeId:4,pkid:"1464960495478902786"},
        {name:'ICESat',SateNum:'1',SateImageNum:'2167',memory:'1.1',typeId:10,pkid:"1464961244002783233"},
      ],
      newsType:[
        {name:'News',type:'1'},
        {name:'IndustryNews',type:'2'},
        // {name:'实验室报告',type:'3'},
      ],
      newForm:{
        page:1,
        limit:4,
        category:'1'
      },
      newAcIndex:0,
      dayImageInfoTimer:null,
      isEnglish: false
    }
  },
  beforeDestroy(){
    clearInterval(this.dayImageInfoTimer)
  },
  mounted() {
    const language = window.localStorage.getItem('language')
    if (language === 'zh') {
      this.isEnglish = false
    }
    if (language === 'en') {
      this.isEnglish = true
    }
  },
  created(){
    let that = this
    this.changeNewsImage()
    this.getNewestPro()
    this.getHotPro()
    this.resoursePro()
    this.resourceSate()
    this.getRegist()
    this.getDownNum()
    this.getNewsList()
    this.getDayImage()
    this.getSumAlgorithm_fuc()
    this.getSUMweixin()
    this.getProductMenuList()
    console.log();
    browseRecord().then(res =>{
      that.serverList[1].num = res.data
    })
    this.getCurrentIp()
  },
  methods:{
    getCurrentIp(){
      //获取客户端IP地址
      function getCusIpAdress(){
          var data;
          let xmlHttpRequest;
          if(window.ActiveXObject){
              xmlHttpRequest = new ActiveXObject("Microsoft.XMLHTTP");
          }else if(window.XMLHttpRequest){
              xmlHttpRequest = new XMLHttpRequest();
          }
          xmlHttpRequest.onreadystatechange=function(){
              if(xmlHttpRequest.readyState == 4){
                  if(xmlHttpRequest.status == 200) {
                      data=xmlHttpRequest .responseText;
                  } else {
                      alert("error:HTTP状态码为:"+xmlHttpRequest.status);
                  }
              }
          };
          xmlHttpRequest.open("get", "https://2022.ip138.com", false);
          xmlHttpRequest.send(null);
          var datalist = data.split("\n");
          var patt = [/[0-9]+.[0-9]+.[0-9]+.[0-9]+/, /来自/, []];
          for (var i in datalist){
              if (patt[0].test(datalist[i]) && patt[1].test(datalist[i])){
                  patt[2].push(patt[0].exec(datalist[i])[0]);
                  patt[2].push(datalist[i].substr(patt[1].exec(datalist[i]).index+3));
              }
          }
          return patt[2];
      }
      let a = getCusIpAdress()
      console.warn('**************');
      console.warn(a);
    },
    prevBtn() {
      this.$refs.mySwiper.swiper.slidePrev()
    },
    nextBtn() {
      this.$refs.mySwiper.swiper.slideNext()
    },
    async getProductMenuList(){
        let {data} = await getShopCarList()
        let res = data
        this.menuListPro = res
    },
    getSUMweixin(){
      sumMutipleStTypes({typeIdList:'1464960963546451969,1464962319824982023'}).then(res =>{
        this.satelliteData[0].SateNum = res.data.satelliteNum
        this.satelliteData[0].SateImageNum = res.data.dataNum
        this.satelliteData[0].memory = this.byte2Auto(parseInt(res.data.spaceUsage))
        console.log(res);
      })

      sumMutipleStTypes({typeIdList:'1464960686177128450'}).then(res =>{
        this.satelliteData[1].SateNum = res.data.satelliteNum
        this.satelliteData[1].SateImageNum = res.data.dataNum
        this.satelliteData[1].memory = this.byte2Auto(parseInt(res.data.spaceUsage))
        console.log(res);
      })

      sumMutipleStTypes({typeIdList:'1464960792288825345'}).then(res =>{
        this.satelliteData[2].SateNum = res.data.satelliteNum
        this.satelliteData[2].SateImageNum = res.data.dataNum
        this.satelliteData[2].memory = this.byte2Auto(parseInt(res.data.spaceUsage))
        console.log(res);
      })

      sumMutipleStTypes({typeIdList:'1464960495478902786'}).then(res =>{
        this.satelliteData[3].SateNum = res.data.satelliteNum
        this.satelliteData[3].SateImageNum = res.data.dataNum
        this.satelliteData[3].memory = this.byte2Auto(parseInt(res.data.spaceUsage))
        console.log(res);
      })

      sumMutipleStTypes({typeIdList:'1464961244002783233'}).then(res =>{
        this.satelliteData[4].SateNum = res.data.satelliteNum
        this.satelliteData[4].SateImageNum = res.data.dataNum
        this.satelliteData[4].memory = this.byte2Auto(parseInt(res.data.spaceUsage))
        console.log(res);
      })

    },
    async getSumAlgorithm_fuc(){
      let res = await getSumAlgorithm()
      this.suanfaTJ = res.data
    },
    async getDayImage(){
      let res = await dayImage()
      let that = this
      that.dayImageInfo = res.data
      this.dayImageInfoTimer = setInterval(() =>{
        that.$refs.mySwiper.swiper.slideNext();
      },1000000*10)
    },
    async getNewestPro(){
      let that = this
      let res = await getNwestList()
      that.newProductData = res.data.list.splice(0,9)
    },
    async getHotPro(){
      let that = this
      let res = await getHotList()
      that.hotData = res.data.list.splice(0,9)
    },
    async resoursePro(){
      let that = this
      let res = await allProductSum()
      that.resourseList[0].num = res.data.totalCount
      that.resourseList[1].num = this.byte2GB(res.data.fileSpaceUsage)
    },
    async resourceSate(){
      let that = this
      let res = await allSatelliteSum()
      that.resourseList[2].num = res.data.count
      that.resourseList[3].num = this.byte2Auto(res.data.spaceUsage).slice(0,-2)

    },
    async getRegist(){
      let that = this
      let res = await serviceStatMenAndGlanced()
      that.serverList[0].num = res.data.sgsUserRegisterNum
      // that.serverList[1].num = res.data.dataGlanced
    },
    async getDownNum(){
      let that = this
      let res = await getIndexSum()
      that.serverList[2].num = this.byte2Auto(res.data.spaceUsage).slice(0,-2)
      that.serverList[2].unit = this.byte2Auto(res.data.spaceUsage).slice(-2)
      that.serverList[3].num = res.data.orderNum
    },
    changeNews(val){
      this.newForm.category = val
      this.getNewsList()
    },
    async getNewsList(){
        let that = this
        let res = await getNews(that.newForm)
        let result = []
        res.data.list.forEach((element,index) => {
          result.push({...element,...{
            day:element.createTime.substr(8,2),
            year:element.createTime.substr(0,7),
            isAC:false
          }})
          if(index===0){
            result[0].isAc = true
          }
        });

        that.newList = result
        that.newAcIndex = 0
        console.log(that.newList);
    },
    changeNewsImage(){
      let that = this
      setInterval(() =>{
        if(that.newAcIndex<that.newList.length-1){
          that.newAcIndex+=1
        }else{
          that.newAcIndex = 0
        }
      },4000)
    },
    hotDataColor(val){
      switch (val) {
        case 0:
          return 'color1'
        case 1:
          return 'color2'
        case 2:
          return 'color3'

        default:
          return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
p{
  margin: 0;
}
.animation{
  -webkit-animation: bounce-down 1s linear infinite;
  animation: bounce-down 1s linear infinite;
}
@keyframes bounce-down {
  25% {transform: translateY(-14px);}
  50%{transform: translateY(0);}
  75% {transform: translateY(14px);}
  100% {transform: translateY(0);}
}
.home{
  width: 100%;
  height: 100%;
  position: relative;
  background-color: rgba(10, 12, 29, 1);
  .content{
    height: calc(100% - 206px);
    color: white;
    .Carousel{
      height: 537px;
      background-image: url("../assets/image/home/pexels-ben-mack-5326990(2).png");
      background-size: 100% 100%;
      position: relative;
      text-align: center;
      &-p1{
        font-size: 36px;
        font-weight: 600;
        letter-spacing:2px;
      }
      &-p2{
        font-size: 18px;
        font-weight: 600;
        margin: 12px 0 17px 0;
      }
      &-p3{
        font-size: 16px;
        line-height: 24px;
        padding:0 10px;
      }
      svg{
        position: absolute;
        left: calc(50% - 16px);
        bottom: 15%;
      }
    }
    .announcement{
      height: 57px;
      background-image: url("../assets/image/home/pexels-ben-mack-5326990 2.png");
      background-size: 100% 100%;
      &-mask{
        height: 60px;
        padding: 0 120px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: rgba(0,0,0,0.5);
        .notice-scroll{
          display: flex;
          align-items: center;
          flex: 1;
          .notice-title{
            font-weight: 800;
            font-size: 18px;
          }
        }
      }

    }
    .dataView{
      @include home_bg_t1_color();
      .model-header{
        display: flex;
        align-items: center;
        justify-content: center;
        .line{
          width: 90px;
          height: 2px;
          background-color: rgba(2, 105, 255, 1);
        }
        .name{
          margin: 0 21px;
          font-size: 26px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 500;
          @include wenzi_color();
        }
      }
      .product-data{
        width: 1200px;
        margin: 0 auto;
        padding: 36px 0;
        .model-name{
          font-size: 32px;
          font-weight: 600;
          position: relative;
          p{
            z-index: 5;
          }
          img{
            background-color: rgba(0,0,0,.5);
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .mask{
          background-color: rgba(0,0,0,.5);
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          right: 0;
          font-size: 18px;
        }
        .mask:hover{
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          right: 0;
          animation: xixihaha 0.7s infinite;
          animation-iteration-count:1;
          animation-fill-mode: forwards;
        }
        @keyframes xixihaha {
          0%{
            background-color: rgba(0,0,0,.5);
          };
          100%{
            background-color: rgba(0,0,0,0);
          };
        }
        &-top{
          margin-top: 36px;
          width: 100%;
          display: flex;
          .ocean-environment{
            flex: 7;
            height: 260px;
            margin-right: 12px;
            background-color: red;
          }
          .Surface-info{
            flex: 13;
            height: 260px;
            margin-left: 12px;
            background-color: red;
          }
        }
        &-bottom{
          margin-top: 24px;
          width: 100%;
          display: flex;
          &-left{
            flex: 1;
            margin-right: 12px;
            &-top{
              width: 100%;
              display: flex;
              .land-Flux{
                flex: 1;
                height: 280px;
                margin-right: 12px;
                background-color: red;
              }
              .polar-glacier{
                flex: 1;
                height: 280px;
                margin-left: 12px;
                background-color: red;
              }
            }
            .polar-atmosphere{
              margin-top: 24px;
              background-color: red;
              width: 100%;
              height: 280px;
            }
          }
          .polar-ocean{
            flex: 1;
            margin-left: 12px;
            background-color: red;
          }
        }
        .more{
          text-align: right;
          margin: 12px 0;
          color: #0269FF;
          cursor: pointer;
        }
      }
      .satellite-data{
        // width: 1200px;

        padding: 24px 0;
        @include home_bg_i2_color();
        .satellite-content{
          width: 1200px;
          margin: 0 auto;
          display: flex;
          padding: 80px 0 0px 0;
          &-list{
            flex: 1;
            margin-right: 12px;
            .satellite-data-site{
              padding: 16px 24px 0 0;
              &:first-child{
                padding-top: 0 !important;
              }
              .satellite-name{
                font-size: 18px;
                font-weight: 600;
                padding-left: 8px;
                @include wenzi_color();
              }
              .satellite-data-box{
                display: flex;
                font-size: 15px;
                color: rgba(159,152,152,1);
                .satellite-ke{flex: 1;}
                .satellite-jing{
                  width: 40%;
                }
                .satellite-memory{flex: 1;}
                span{
                  margin: 6px 0 7px 5px;
                }
                .satellite-memory{
                  text-align: center;
                }
              }
            }
          }
          &-image{
            flex: 1;
            margin-left: 12px;
            img{
              width: 100%;
              height: 425px;
              object-fit: cover;
            }
          }
        }

        .meiriyitu{
          width: 1200px;
          margin: 0 auto;
          padding: 80px 0 0px 0;
          .jia-p{
            @include wenzi_color();
          }
          p{
            display: flex;
            justify-content: space-between;
          }
        }
        .more{
          text-align: right;
          margin: 12px 0;
          padding: 0 24px;
          cursor: pointer;
          color: #0269FF;
        }
      }
      .related-suggestion{
        @include home_bg_i3_color();
        .width12{
          margin: 0 auto;
          width: 1200px;
          padding: 36px 0;
          display: flex;
          justify-content: space-between;
        }
        .related-layout{
          flex: 1;
          @include home_bg_relative_color();
          border-radius: 15px;
          padding: 32px 48px;
          .more{
            text-align: center;
            background: #FFFFFF;
            border-radius: 28px;
            opacity: 0.69;

            font-size: 14px;
            cursor: pointer;
            margin: 0 auto;
            padding: 2px 8px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #0269FF;
            margin-top: 20px;
          }
        }
        .data-list{
          height: 375px;
          overflow: auto;
          p{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 18px 0;
          }
          .hot-date-site{
            display: flex;
            justify-content: space-between;
            margin: 17px 0;
            color: #eaeaea;
            .color1{
              color: #e11010;
              color: #FFFFFF;
              font-weight: 600;
            }
            .color2{
              color: #f06e07;
              color: #FFFFFF;
              font-weight: 600;
            }
            .color3{
              color: #eaad0a;
              color: #FFFFFF;
              font-weight: 600;
            }
            &-left{
              img{
                width: 22px;
                height: 22px;
                margin-right: 8px;
              }
              display: flex;
              align-items: center;
              max-width: 430px;
            }
            &-right{}
          }
        }
        .new{
          margin-right: 12px;
        }
        .hot{
          margin-left: 12px;
        }
      }
      .News-Center{
        padding: 36px 0;
        @include home_bg_i4_color();
        .news-showcase{
          display: flex;
          margin: 0 auto;
          margin-top: 18px;
          width: 1200px;

          .image-box{
            flex: 2;
            margin-right: 12px;

            img{
              margin-top: 60px;
              width: 450px;
              height: 350px;
            }
          }
          .news-list{
            margin-left: 12px;
            flex: 5;
            .news-type{
              height: 36px;
              display: flex;
              justify-content: flex-end;
              cursor: pointer;
              .new-site{
                // width: 80px;
                height: 34px;
                @include home_bg_t3_color();
                border-radius: 4px;
                padding: 0 24px;

                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #0269FF;
              }
              .new-site-ac{
                // width: 80px;
                height: 36px;
                background-color: rgba(2, 105, 255, 1);
                border-radius: 4px;
                padding: 0 24px;

                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
              }
            }
            &-box{
              width: 100%;
              height: 390px;
              display: flex;
              flex-direction: column;
              .news-site{
                flex: 1;
                margin-top: 8px ;
                width: 100%;
                display: flex;
                align-items: center;
                .news-date{
                  width: 80px;
                  height: 100%;

                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;

                  .day{
                    font-size: 26px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #A4A4A4;
                  }
                  .year{
                    font-size: 11px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #A4A4A4;
                  }
                }
                .news-line{
                  height: 70%;
                  width: 1px;
                  background-color: rgba(68,66,69,1);
                }
                .news-content{
                  flex: 1;
                  padding:0 0 0 12px;
                  &-title{
                    font-size: 18px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    @include wenzi_color;
                    cursor: pointer;
                  }
                  &-title-ac{
                    font-size: 18px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: rgba(2, 105, 255, 1);
                  }
                  &-detail{
                    font-size: 15px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #A4A4A4;
                    text-align: justify;

                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                  }
                }
              }

            }

          }
        }
        .more{
          text-align: right;
          margin: 12px 0 0 0;
          margin: 0 auto;
          width: 1200px;
          cursor: pointer;
          color: #0269FF;
          padding: 0 12px;
        }
      }
      .data-view-title{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 24px;
        line-height: 60px;
        border-bottom: 1px solid rgba(221,213,213,1);
        span:first-child{
          font-size: 20px;
          color: rgba(6,42,168,1);
        }
        span:last-child{
          font-size: 15px;
          color: black;
        }
      }
      .count-box{
        display: flex;
        height: 180px;
        align-items: center;
        .count-site{
          flex: 1;
          text-align: center;
          position: relative;
          img{
            width: 120px;
            height: 120px;
          }
          .count-line{
            position: absolute;
            right: 0;
            top: 0;
            height: 100%;
            width: 1px;
            background-color: rgba(221,221,221,1);
          }
          .count-num{
            font-size: 26px;
            font-family: URWDIN-Demi, URWDIN;
            font-weight: normal;
            color: #0269FF;
          }
          .count-unit{
            margin-left: 10px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #0269FF;
          }
          .count-name{
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #C1C1C1;
          }
        }
      }
      .Resource-Statistics{
        padding-top: 68px;
        width: 1200px;
        margin: 0 auto;
      }
      .Service-Statistics{
        padding-top: 34px;
        width: 1200px;
        margin: 0 auto;
      }
      .white-box{
        width: calc(100% - 24px);
        height: calc(100% - 24px);
        background: white;
      }
    }
  }
}
.product-img{
  display: flex;
  justify-content: space-between;
  .l1{
    width: 232px;
    height: 580px;
  }
  .right-img{
    width: 956px;
    height: 580px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .right-img-top{
      height: 326px;
      display: flex;
      justify-content: space-between;
      .t1{
        width: 350px;
        cursor: pointer;
      }
      .t2{
        width: 232px;
        cursor: pointer;
      }
      .t3{
        width: 350px;
        cursor: pointer;
      }
    }
    .right-img-bottom{
      height: 243px;
      display: flex;
      justify-content: space-between;
      .b1{
        width: 292px;
        cursor: pointer;
      }
      .b2{
        width: 292px;
        cursor: pointer;
      }
      .b3{
        width: 350px;
        cursor: pointer;
      }
    }
  }
}
</style>
